import { MathEx } from '@ykob/js-util'
import Hookes from '../Hookes'
import SmoothScrollManager from './'

export default class ParallaxItem {
  height = 0
  top = 0

  rangeX: number
  ratioX: number
  unitX: string
  rangeY: number
  ratioY: number
  unitY: string

  constructor(
    public elm: HTMLElement,
    public scrollManager: SmoothScrollManager,
    public hookes: Hookes,
    opt: { [key: string]: any } = {}
  ) {
    this.rangeX = opt.rangeX ? opt.rangeX : 10000
    this.ratioX = opt.ratioX ? opt.ratioX : 0
    this.unitX = opt.unitX ? opt.unitX : 'px'
    this.rangeY = opt.rangeY ? opt.rangeY : 10
    this.ratioY = opt.ratioY ? opt.ratioY : 0.012
    this.unitY = opt.unitY ? opt.unitY : '%'
  }

  init(scrollTop: number): void {
    this.elm.style.transform = ''
    const rect = this.elm.getBoundingClientRect()
    this.height = rect.height
    this.top = scrollTop + rect.top
    this.elm.style.backfaceVisibility = 'hidden'
    this.render(false)
  }

  render(iwWorking: boolean): void {
    let x = 0
    let y = 0
    if (iwWorking) {
      x = MathEx.clamp(
        this.hookes.velocity[0] * this.ratioX,
        this.rangeX * -1,
        this.rangeX
      )
      y = MathEx.clamp(
        (this.hookes.velocity[1] - (this.top + this.height * 0.5)) *
          this.ratioY,
        this.rangeY * -1,
        this.rangeY
      )
    }
    this.elm.style.transform = `translate3D(${x}${this.unitX}, ${y}${this.unitY}, 0)`
  }
}
